import type { Client } from "./primitives";

/**
 * Shared client / partner roster rendered in the editorial LogoGrid
 * (hero, dark variant; trust, light variant). One source of truth for
 * the one-pager and the marketing homepages. Light-variant artwork
 * (dark on transparent) so it can be inverted to white on dark fields.
 */
export const MERCURY_CLIENTS: Client[] = [
  // Row 1 — UK government departments.
  { name: "HM Government", src: "/logos/light/hm-government.svg", tall: true, subtitle: "Crown Service" },
  { name: "Department for Education", src: "/logos/light/dfe.png", tall: true, subtitle: "Schools & skills" },
  { name: "Department for Work and Pensions", src: "/logos/light/dwp.svg", tall: true, subtitle: "DWP" },
  { name: "Crown Commercial Service", src: "/logos/light/ccs.png", tall: true, subtitle: "CCS" },

  // Row 2 — public sector regulators + manufacturing innovation
  { name: "IfATE", src: "/logos/light/ifate.svg", subtitle: "Apprenticeships regulator" },
  { name: "HVM Catapult", src: "/logos/light/hvm-catapult.png", subtitle: "Manufacturing innovation" },
  { name: "MTC", src: "/logos/light/mtc.png", subtitle: "Manufacturing Technology Centre" },
  { name: "Harrison Parrott", src: "/logos/light/harrison-parrott.svg", subtitle: "Arts management agency" },

  // Row 3 — private sector
  { name: "PrimaryBid", src: "/logos/light/primary-bid.svg", subtitle: "Listed-company capital" },
  { name: "Augmentive", src: "/logos/light/augmentive.svg", subtitle: "Health platform" },
  { name: "Forestreet", src: "/logos/light/forestreet.svg", subtitle: "Market intelligence" },
  { name: "Lucy Vail Floristry", src: "/logos/light/lucy-vail-floristry.svg", subtitle: "Luxury florist" },
];
